import { useToast } from '../../lib/chakraUi/hooks';
import { User } from '../../types';
import { useSubscribeToIndividualCreditEnquiryCompleted } from '../../websocketApi/creditBureau';

export const useIndividualCreditEnquiryNotification = (
  userId: User['id'],
  onCompleted?: () => void,
): void => {
  const toast = useToast();

  useSubscribeToIndividualCreditEnquiryCompleted(userId, () => {
    toast({
      closable: true,
      description: 'The credit report is now available on the applicant.',
      title: 'Credit check complete',
      type: 'success',
    });

    onCompleted?.();
  });
};
